<app-header></app-header>
<div class="mastercontent">
    <router-outlet></router-outlet>
</div>